import { useEffect, useState } from "react";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { FileService } from "../../core/services/FileService";
import { Modal } from "../theme/Component/Modal";
import { VisorAnyDocument } from "../documents/VisorAnyDocument";
import { _Inbox, _RecordDocumentTRD } from "../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../theme/Component/PrintJson";
import { Alert } from "../theme/Component/Alert";


interface Props {
    ID: number;
}


export const    DocumentExp = ({ ID }: Props) => {

    const _recordDocument = useDataBean(_RecordDocumentTRD);
    const { instance, lista, setLista, setBean, bean } = _recordDocument;
    const fileService = new FileService();

    const [modal, setModal] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-xl' });

    useEffect(() => {
        getDocuments()
    }, [ID])

    const getDocuments = () => {
                
        if(ID)
        {
            const data = {
                IDRecordProcess: ID
            }
            _recordDocument.getLista(data, null);
        }
    }

    const vierDocument = (item: any) => {
        const fileType = item.Media ? item.Media.split('.').pop()?.toLowerCase() : "pdf";
        setBean({...item, "TypeName": fileType});                       
        setModal({ ...modal, "view": true });
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {lista.length === 0 ? (
                    <Alert clase="primary">
                        <p>No hay documentos asociados</p>
                    </Alert>
                ) :
                    (
                        <>
                             <div className="list-group">
                            {
                                lista.map((item: any, index: number) => {

                                    const rawText = item.DataBeanProperties;

                                    return (
                                        <div className="row mt-3" key={index}>
                                            <div className="col-md-12">
                                                {!rawText || !rawText.MediaContext ? (
                                                    <p>No hay documentos para mostrar</p>
                                                ) : (
                                                   
                                                        <button onClick={() => { vierDocument(rawText) }} key={index} type="button" className="list-group-item list-group-item-action" aria-current="true">
                                                            <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                            {rawText.Name} <br /> <small>{rawText.LastUpdate}</small> 
                                                            {/* <small className="text-danger cursor">eliminar</small> */}
                                                        </button>                                                                                                          
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            }
                              </div>
                        </>
                    )
                }
            </div>            
            <div className="col-md-12">
                {/* <PrintJson json={lista}/> */}
                <Modal modal={modal} updateModal={setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <VisorAnyDocument url={fileService.getUrlFile(bean.MediaContext, bean.Media)} type={bean?.TypeName} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
}
